export default __webpack_public_path__ + "static/media/car.4920b56f.png";